import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getTranslate, Translate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { Typography } from '@material-ui/core';

import urls from '../../../app/urls';
import logo from '../../../common/image/logo negativ stor.svg';
import { Image } from '../../../youwell-common/components';
import Auth from '../../../youwell-common/Auth';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.grey1,
        background: theme.colors.blue4,
        padding: theme.spacing(0, 6),
    },

    logo: {
        width: 100,
        marginRight: theme.spacing(6),
    },
    title: {
        display: 'flex',

        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    flex: {
        flex: '1 1 auto',
    },
    titleText: {
        width: 150,
    },
    link: {
        marginLeft: theme.spacing(2),
    },
    hideOnSmall: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
});

class Header extends React.Component {
    render() {
        const {
            classes, className, hideHeaderLinks, headerPageTitle, profileData,
        } = this.props;

        const isLoggedIn = Auth.isUserAuthenticated() && profileData;

        return (
            <div className={classnames(className, classes.root)}>
                <Link to={`${urls.home}`}>
                    <Image src={logo} alt="Logo" className={classes.logo} />
                </Link>
                <Link to={`${urls.home}`} className={classes.title}>
                    <Typography variant="subtitle1" color="inherit" className={classes.titleText}>
                        <Translate id="frontpage.aSimplerDayForKids" />
                    </Typography>
                </Link>

                <div className={classes.flex} />

                {headerPageTitle && (
                    <Typography variant="h5" color="primary">
                        {headerPageTitle}
                    </Typography>
                )}

                {!hideHeaderLinks && (
                    <>
                        <a href="#about" className={classnames(classes.link, classes.hideOnSmall)}><Translate id="header.aboutVimo" /></a>
                        <a href="#price" className={classnames(classes.link, classes.hideOnSmall)}><Translate id="header.price" /></a>
                        <a href="#help" className={classnames(classes.link, classes.hideOnSmall)}><Translate id="header.help" /></a>
                        <a href="#contact" className={classnames(classes.link, classes.hideOnSmall)}><Translate id="header.contact" /></a>
                        {isLoggedIn
                            ? <Link to={urls.logout} className={classes.link}><Translate id="header.logout" /></Link>
                            : (
                                <>
                                    <Link to={urls.register} className={classnames(classes.link, classes.hideOnSmall)}><Translate id="header.tryNow" /></Link>
                                    <Link to={`${urls.login}/${urls.loginParts.student}`} className={classes.link}><Translate id="header.studentLogin" /></Link>
                                    <Link to={urls.login} className={classes.link}><Translate id="header.login" /></Link>
                                </>
                            )
                        }
                    </>
                )}
            </div>
        );
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    hideHeaderLinks: PropTypes.bool,
    headerPageTitle: PropTypes.string,
    profileData: PropTypes.object,
};

Header.defaultProps = {
    className: null,
    hideHeaderLinks: false,
    headerPageTitle: null,
    profileData: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profileData: state.auth.profileData,
});

export default connect(mapStateToProps)(withStyles(styles)(Header));
